<template>
  <div class="bubble-box sc-message--file" v-ripple role="button" v-on:click="clicked" :id="message.id">

    <v-layout align-center style="padding:5px 0;">
      <v-icon large style="margin-left:-4px;">{{playIcon}}</v-icon>

      <v-layout column>
        <div style="vertical-align: middle;">
          <span class="sc-message--file-title">{{audioTime}}</span>
          <v-icon small class="sc-message--file-icon" v-if="hasTimerIcon">{{timerIcon}}</v-icon>
        </div>
      </v-layout>
    </v-layout>

    <div class="sc-message--file-state">
      <div class="inner-state">
        <MessageState :state="state" :time="time" />
      </div>
    </div>
    
  </div>
</template>

<script>
  import MessageState from './MessageState.vue'
  import timeUtils from '@utils/timeUtils'
  import { EventBus } from '@/event-bus'

  export default {
    components: {
      MessageState
    },
    data () {
      return {
        playing: false,
        playIcon: 'play_arrow',
        duration: "",
        audioTime: "",
        playTimer: null,
        playTime: 0
      }
    },
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    computed: {
      time() {
        return timeUtils.getShortTime(this.message.time);
      },
      state() {
        return this.message.sent ? this.message.state : null
      },
      timerIcon() {
        return this.message.state == this.states.MessageRead ? 'history' : 'visibility'
      },
      hasTimerIcon() {
        return this.message.data.ttl >= 0 && !this.message.sent
      },
    },
    methods: {
      clicked() {
        if (!this.playing) {
          let extension = this.message.content.slice(this.message.content.lastIndexOf(".")+1)
          this.$store.dispatch('decodeFile',this.message.content).then((audioData) => { 
            let decryptedPath = 'data:audio/mpeg;base64,' + audioData 
            EventBus.$emit('audio-message-clicked', {path: decryptedPath, messageId: this.message.id, play: true})
          })
        } else {
          EventBus.$emit('audio-message-clicked', {path: "", messageId: this.message.id, play: false})  
          this.audioMessageStop(this.message.id)
        }       
      },
      timerUpdate() {
        this.playTime += 1000
        if (this.message.data.duration > this.playTime && this.playing) {
          this.audioTime = timeUtils.getDurationTime(this.playTime)
          this.playTimer = setTimeout(this.timerUpdate, 1000)
        } else {    
          this.playing = false
          this.playIcon = 'play_arrow'
          this.playTime = 0
          this.audioTime = this.duration
          EventBus.$emit('audio-message-play-next')
        }
      },
      audioMessageStop(messageId) {
        if (messageId == this.message.id) {
          this.playIcon = 'play_arrow'
          this.playing = false
          this.audioTime = this.duration
          clearTimeout(this.playTimer)
        }
      },
      audioMessagePlaing(messageId) {
        if (messageId == this.message.id) {
          this.playIcon = 'stop'
          this.playing = true
          this.audioTime = timeUtils.getDurationTime(this.playTime)
          this.playTimer = setTimeout(this.timerUpdate, 1000);
        }
      },
      audioMessagePlay(messageId) {
        if (messageId == this.message.id) {
          this.clicked()
        }
      }
    },
    mounted() {
      this.duration = timeUtils.getDurationTime(this.message.data.duration)
      this.audioTime = this.duration
      EventBus.$on('audio-message-stop', this.audioMessageStop)
      EventBus.$on('audio-message-play', this.audioMessagePlay)
      EventBus.$on('audio-message-plaing', this.audioMessagePlaing)
    },
    beforeDestroy() {
      EventBus.$off('audio-message-stop')
      EventBus.$off('audio-message-play')
      EventBus.$off('audio-message-plaing')
    },
  }
</script>

<style>
  .sc-message--file {
    opacity:1;
    border-radius: inherit;
  }
  .sc-message--file:hover {
    opacity:0.8;
  }

  .sc-message--file-state .inner-state {
    /* align to the same position with text message state */
    margin-left: 16px;
    margin-bottom: 6px;
  }
  .sc-message--file-size {
    font-size: 85%;
    color:var(--v-alternativeBackground-base);
  }
  .sc-message--file-icon {
    font-size: 85%;
  }
</style>
